var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUploadIcon = function SvgUploadIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "main-color-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.744,
    height: 16
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108780",
    d: "M15.628 9.116a1.117 1.117 0 0 1 1.116 1.116v3.349A2.419 2.419 0 0 1 14.325 16H2.419A2.419 2.419 0 0 1 0 13.581v-3.349a1.117 1.117 0 0 1 2.233 0v3.349a.186.186 0 0 0 .186.186h11.907a.186.186 0 0 0 .186-.186v-3.349a1.117 1.117 0 0 1 1.116-1.116Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108781",
    d: "M7.825.236a.754.754 0 0 1 1.094 0l2.96 3.116a.769.769 0 0 1-.547 1.3h-1.1v5.953a1.3 1.3 0 0 1-1.3 1.3H7.816a1.3 1.3 0 0 1-1.3-1.3V4.652h-1.1a.769.769 0 0 1-.547-1.3Z"
  })));
};
export default SvgUploadIcon;